import { IconButton, ListItemText, Stack, Tooltip } from '@mui/material';
import { useLocales } from 'src/locales';
import { FormatTime } from 'src/utils/formatTime';
import Iconify from '../iconify';

interface RecordListItemProps {
  title: string;
  date: string;
  openPreview: () => void;
  removeRecord: () => void;
}

const RecordListItem = ({
  title,
  date,
  openPreview,
  removeRecord,
}: RecordListItemProps) => {
  const { translate } = useLocales();
  return (
    <Stack
      gap={1}
      direction="row"
      alignItems="center"
      sx={{
        cursor: 'pointer',
        p: 1,
        borderRadius: 1,
        '&:hover': {
          backgroundColor: (theme) => theme.palette.action.hover,
        },
      }}
      onClick={openPreview}
    >
      <ListItemText
        primary={title}
        secondary={FormatTime.DateTime(date)}
        primaryTypographyProps={{ variant: 'body2' }}
        secondaryTypographyProps={{ variant: 'caption' }}
      />
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          removeRecord();
        }}
      >
        <Tooltip
          title={translate('shared.buttons.remove')}
          placement="top"
          arrow
        >
          <Iconify icon="tabler:circle-x" />
        </Tooltip>
      </IconButton>
    </Stack>
  );
};

export default RecordListItem;
